module.exports = __webpack_public_path__ + "img/edit.07d31b77.png";